<div class="table__responsive" [class.select-hover-only]="checkFunctionality('select-hover-only')" [class.selectable]="checkFunctionality('selectable')" [class.modal]="checkFunctionality('modal')" [class.no-padding]="checkFunctionality('no-padding')">

  <div class="table-wrapper">
    <div class="title-wrapper">
      <h3 class="mb-2">{{ tableTitle }}</h3>
    </div>
    <div class="search-wrapper" *ngIf="searchInput">
      <mat-form-field appearance="standard" class="mat-typography">
        <span>Buscar:</span>
        <input matInput (keyup)="applyFilter($event)" placeholder="Buscar..." #input>
      </mat-form-field>
    </div>

    <div class="table-wrapper-inner limited">
      <table mat-table [dataSource]="dataSource" matSort class="not-wrap">

        <!-- Columns -->
        <ng-container [matColumnDef]="column.variable" *ngFor="let column of displayedColumns">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.displayedName }}</th>
          <td mat-cell *matCellDef="let row let i = index">

            <!-- <div *ngIf="column.variable != 'options' && column.variable != 'Estado' && column.variable != 'area' && column.variable != 'fldCriticality'"> -->
            <div *ngIf="!(['options-trade-agreements', 'status', 'options-charges', 'options-payments', 'options-shops', 'chargeState', 'billState', 'options-products', 'options-customers', 'nested-shops', 'options-user', 'permissions_concat', 'options-roles', 'branch_offices_options', 'user_generator_custom', 'user_approver_custom', 'status_en', 'options-objectives', 'options-report-objectives', 'options-asset-types', 'options-asset-requests', 'options-asset-pickups', 'pickup_batch_status', 'gps_location', 'asset_request_status'].indexOf(column.variable) > -1)">
              {{ row[column.variable] || '---' }}
          </div>

            <div *ngIf="column.variable == 'gps_location'">
              <a *ngIf="row.latitude && row.longitude" class="icon-btn info" (click)="viewAssetLocation(row)" title="Ver en el mapa">
                <i class="fa-light fa-map-location-dot m-auto text-[18px] text-[#475467]"></i>
              </a>
              <span *ngIf="!(row.latitude && row.longitude)">---</span>
            </div>

            <div *ngIf="column.variable == 'asset_request_status'">
              <div class="badge">
                <span [ngClass]="{'success': row.status == 'completed', 'pending': row.status == 'pending' || row.status == 'approved' || row.status == 'fulfilled', 'null': row.status == 'rejected'}">
                  {{ row.status_label || row.status }}
                </span>
              </div>
            </div>

            <div *ngIf="column.variable == 'pickup_batch_status'">
              <div class="badge">
                <span [ngClass]="{'success': row.status == 'completed', 'pending': row.status == 'pending' || row.status == 'picked_up'}">
                  {{ row.status_label || row.status }}
                </span>
              </div>
            </div>

            <div *ngIf="column.variable == 'options-asset-pickups'">
              <a class="icon-btn success" (click)="viewAssetPickup(row)" title="Ver recojo / documento">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </a>
            </div>

            <div *ngIf="column.variable == 'chargeState'">
              <div class="badge">
                <span [ngClass]="{'success': row[column.variable] == 'Cobrado', 'pending': row[column.variable] == 'Pendiente', 'null': row[column.variable] == 'No cobrado'}">
                  {{ row[column.variable] }}
                </span>
              </div>
            </div>

            <div *ngIf="column.variable == 'billState'">
              <div class="badge">
                <span [ngClass]="{'success': row[column.variable] == 'Activa', 'pending': row[column.variable] == 'Por aprobar', 'null': row[column.variable] == 'Anulado'}">
                  {{ row[column.variable] }}
                </span>
              </div>
            </div>

            <div *ngIf="column.variable == 'options-trade-agreements'">
              <a class="icon-btn info" (click)="viewTradeAgreement(row.id)">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </a>
              <!-- <a class="icon-btn success" (click)="editTradeAgreement(row.id)" *ngIf="userPermissions.commercial_agreements.indexOf('update') >= 0">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </a> -->
              <!-- <button class="icon-btn danger" (click)="deleteTradeAgreement(row.id)" *ngIf="userPermissions.commercial_agreements.indexOf('delete') >= 0">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button> -->
            </div>

            <div *ngIf="column.variable == 'options-assets'">
              <a class="icon-btn success" (click)="editAsset(row.id)" title="Editar">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </a>
              <a class="icon-btn info" (click)="viewAssetHistory(row)" title="Ver historial">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </a>
              <a class="icon-btn success" (click)="returnAsset(row)" title="Registrar devolución" *ngIf="row.status_raw == 'assigned'">
                <img src="../../../assets/qh-suite/icons/check_circle.svg" alt="icon">
              </a>
              <button class="icon-btn danger" (click)="deleteAsset(row.id)" title="Eliminar">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button>
            </div>

            <div *ngIf="column.variable == 'options-asset-types'">
              <a class="icon-btn success" (click)="editAssetType(row.id)">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </a>
              <button class="icon-btn danger" (click)="deleteAssetType(row.id)">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button>
            </div>

            <div *ngIf="column.variable == 'options-asset-requests'">
              <a class="icon-btn info" (click)="editAssetRequest(row.id)" title="Completar: falta subir el acta de entrega y/o el contrato de custodia firmados" *ngIf="row.status == 'fulfilled'">
                <img src="../../../assets/qh-suite/icons/check_circle.svg" alt="icon">
              </a>
              <a class="icon-btn success" (click)="editAssetRequest(row.id)" title="Editar" *ngIf="row.status != 'fulfilled'">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </a>
              <button class="icon-btn danger" (click)="deleteAssetRequest(row.id)" *ngIf="row.status == 'pending'">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button>
            </div>

            <div *ngIf="column.variable == 'options-trade-agreements-2'">
              <a class="icon-btn success" (click)="editTradeAgreement2(row.id)">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </a>
              <a class="icon-btn info" (click)="viewTradeAgreement2(row?.commercial_agreements_products)">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </a>
              <button class="icon-btn danger" (click)="deleteTradeAgreement2(row.id)">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button>
              <!--<button class="icon-btn danger" (click)="deleteTradeAgreement(row.id)" *ngIf="userPermissions.commercial_agreements.indexOf('delete') >= 0">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button> -->
            </div>

            <div *ngIf="column.variable == 'branch_offices_options'">
              <a class="icon-btn info" (click)="viewBranchOffice(row.id)">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </a>
              <a class="icon-btn success" (click)="editBranchOffice(row.id)">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </a>
              <button class="icon-btn danger" (click)="deleteBranchOffice(row.id)">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button>
            </div>

            <div *ngIf="column.variable == 'user_generator_custom'">
              {{ row['user_generator_custom'] || 'Sistema' }}
            </div>

            <div *ngIf="column.variable == 'user_approver_custom'">
              {{ row['user_approver'] || 'Sistema' }}
            </div>

            <div *ngIf="column.variable == 'status'">
              <div class="badge">
                <span [ngClass]="{'success': ['Activo', 'Normal', 'Disponible'].indexOf(row[column.variable]) > -1 ,
                                  'pending': ['Pendiente', 'Confirmacíon pendiente', 'Asignado'].indexOf(row[column.variable]) > -1,
                                  'null': ['Inactivo', 'Baneado', 'Dañado'].indexOf(row[column.variable]) > -1}">
                  {{ row[column.variable] }}
                </span>
              </div>
            </div>

            <div *ngIf="column.variable == 'status_en'">
              <div class="badge">
                <span class="pending" *ngIf="row['status'] == 'active'">
                  Pendiente
                </span>
                <span class="success" *ngIf="row['status'] == 'inactive'">
                  Pagado
                </span>
              </div>
            </div>

            <div *ngIf="column.variable == 'permissions_concat'">
                <div class="badge_wrapper" id="col-{{i}}">
                  {{ stringSetClass(row[column.variable], i) }}
                </div>
            </div>

            <div *ngIf="column.variable == 'options-roles'">
                <button class="icon-btn success" (click)="viewRole(row.role_id)">
                  <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
                </button>
                <button [routerLink]="['/dashboard/edit-charge']" class="icon-btn success" (click)="editRole(row.role_id)" *ngIf="userPermissions.roles.indexOf('update') >= 0">
                  <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
                </button>
                <button class="icon-btn danger" (click)="deleteRole(row.role_id)" *ngIf="userPermissions.roles.indexOf('delete') >= 0">
                  <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
                </button>
            </div>

            <div *ngIf="column.variable == 'options-charges'">
                <button class="icon-btn success" (click)="viewCharge(row)">
                  <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
                </button>
                <button [routerLink]="['/dashboard/edit-charge']" class="icon-btn success" (click)="editCharge(row.id)" *ngIf="userPermissions.due_payments.indexOf('update') >= 0">
                  <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
                </button>
                <button class="icon-btn danger" (click)="deleteCharge(row.id)" *ngIf="userPermissions.due_payments.indexOf('delete') >= 0">
                  <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
                </button>
            </div>

            <div *ngIf="column.variable == 'options-payments'">
              <a class="icon-btn info" (click)="viewPayment(row.id)">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </a>
              <!-- <a (click)="editPayment(row.id)" class="icon-btn success" *ngIf="userPermissions.payments.indexOf('update') >= 0">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </a> -->
              <button class="icon-btn danger" (click)="deletePayment(row.id)" *ngIf="userPermissions.payments.indexOf('delete') >= 0">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button>
            </div>

            <div *ngIf="column.variable == 'options-billing'">
              <a [routerLink]="['/dashboard/edit-bill']" class="icon-btn success">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </a>
              <button class="icon-btn danger">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button>
            </div>

            <div *ngIf="column.variable == 'options-products'">
              <button (click)="viewProduct(row.id)" class="icon-btn info">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </button>
              <button (click)="editProduct(row.id)" class="icon-btn success" *ngIf="userPermissions.products.indexOf('update') >= 0">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </button>
              <button (click)="deleteProduct(row.id)" class="icon-btn danger">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon" *ngIf="userPermissions.products.indexOf('delete') >= 0">
              </button>
            </div>

            <div *ngIf="column.variable == 'options-objectives'">
              <a class="icon-btn info" (click)="viewObjective(row)">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </a>
              <a class="icon-btn edit" (click)="editObjective(row)"> <img src="../../../assets/qh-suite/icons/edit.svg" alt="Editar">
              </a>
              <button (click)="deleteObjective(row)" class="icon-btn danger">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon" *ngIf="true">
              </button>
            </div>

            <!-- <div *ngIf="column.variable == 'options-customers'">
              <a  [routerLink]="['/dashboard/customer-details']" class="icon-btn info">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </a>
              <a [routerLink]="['/dashboard/edit-customer']" class="icon-btn success">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </a>
              <button class="icon-btn danger">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon">
              </button>
            </div> -->

            <div *ngIf="column.variable == 'options-shops'">
              <!-- <button (click)="redirectShop(row.organization_id)" class="icon-btn info">
                <img src="../../../assets/qh-suite/icons/image-user.svg" alt="icon">
              </button> -->
              <button (click)="editShop(row.organization_id)" class="icon-btn success" *ngIf="userPermissions.organizations.indexOf('update') >= 0">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon" class="pointer-events-none">
              </button>
              <button (click)="deleteShop(row.organization_id)" class="icon-btn danger" *ngIf="userPermissions.organizations.indexOf('delete') >= 0">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon" class="pointer-events-none">
              </button>
              <button (click)="settingsView(row.organization_id)" class="icon-btn danger" *ngIf="userPermissions.organizations.indexOf('config') >= 0">
                <img src="../../../assets/qh-suite/icons/settings.svg" alt="icon" class="pointer-events-none">
              </button>
              <button (click)="viewUserInformation(row.organization_id)" class="icon-btn danger">
                <img src="../../../assets/qh-suite/icons/user.svg" alt="icon" class="pointer-events-none">
              </button>
              <button (click)="redirectShopV2(row.organization_id)" class="icon-btn danger">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon" class="pointer-events-none">
              </button>
            </div>

            <div *ngIf="column.variable == 'options-user'">
              <button (click)="viewUser(row.id)" class="icon-btn info">
                <img src="../../../assets/qh-suite/icons/visibility.svg" alt="icon">
              </button>
              <button (click)="editUser(row.id)" class="icon-btn success" *ngIf="userPermissions.users.indexOf('update') >= 0">
                <img src="../../../assets/qh-suite/icons/edit.svg" alt="icon">
              </button>
              <button (click)="deleteUser(row.id)" class="icon-btn danger">
                <img src="../../../assets/qh-suite/icons/delete.svg" alt="icon" *ngIf="userPermissions.users.indexOf('delete') >= 0">
              </button>
            </div>

            <div *ngIf="column.variable == 'options-report-objectives'" class="text-center">
              <button
                type="button"
                class="btn btn-primary"
                [disabled]="!row.arrived_data || row.arrived_data.length === 0"
                (click)="viewArrivedData(row)">
                Ver Detalle ({{ row.arrived_data?.length || 0 }})
              </button>
            </div>

            <div *ngIf="column.variable == 'nested-shops'">
              <div class="nested-buttons">
                <button class="btn btn-outline-accent">Agregar</button>
                <select class="btn btn-primary">
                  <option value="0">Sucursales</option>
                  <option value="1">Sucursal 1</option>
                </select>
              </div>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns_aux"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns_aux;" (click)="[getRowInfo(row), redirectShop(row.organization_id, checkFunctionality('select-hover-only'), $event)]" [class.selected]="rowSelected == row"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="30" class="text-center" *ngIf="data.length"> No se encontraron resultados</td>
        </tr>

      </table>
    </div>
  </div>
  <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" (page)="pageEvent = $event"></mat-paginator>
</div>
